<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <div class="card-width">
        <el-card>
          <div slot="header" class="card-wrap flex-center-center fz24">
            <div
                class="tab-item tab-item-active"
            >
              经办人认证
            </div>
          </div>

          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="150px"
              class="demo-ruleForm"
              v-loading="loading"
          >
            <div class="upload-image">
              <div class="fz14 top-text">
                <div class="mb5" style="width: 100px">
                  <span style="color: red" class="mr5">*</span>上传材料：
                </div>
                <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
<!--                <div class="fc-407FFF pointer" @click="downAuth">下载授权书</div>-->
              </div>

              <el-form-item label-width="0px" prop="operatorIdCardFront">
                <el-input style="display: none" v-model="ruleForm.operatorIdCardFront"></el-input>
                <el-upload
                    ref="operatorIdCardFront"
                    class="avatar-uploader"
                    multiple
                    :show-file-list="false"
                    :before-upload="(e) => handleBeforeUpload(e, 5)"
                    :on-change="onChangeFront"
                    action="/"
                    accept="image/*"
                >
                  <div class="flex-dir-center-center" style="width: 100%;height: 100%" @click.stop="changeUpload('operatorIdCardFront')">
                    <img class="image-card" v-if="imageUrlOperatorFront" :src="imageUrlOperatorFront" alt/>
                    <img
                        class="icon-check"
                        v-if="imageUrlOperatorFront"
                        @click.stop="checkImage('operatorFront')"
                        src="@/assets/login/icon-check-img.png"
                    />
                    <img v-if="!imageUrlOperatorFront" src="@/assets/login/image-card-people.png" alt/>
                    <span v-if="!imageUrlOperatorFront" class="fz14 fc9">上传经办人身份证人像面照片</span>
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item label-width="0px" prop="operatorIdCardBack">
                <el-input style="display: none" v-model="ruleForm.operatorIdCardBack"></el-input>
                <el-upload
                    ref="operatorIdCardBack"
                    class="avatar-uploader"
                    multiple
                    :show-file-list="false"
                    :before-upload="(e) => handleBeforeUpload(e, 6)"
                    :on-change="onChangeReserve"
                    action="/"
                    accept="image/*"
                >
                  <div class="flex-dir-center-center" style="width: 100%;height: 100%" @click.stop="changeUpload('operatorIdCardBack')">
                    <img class="image-card" v-if="imageUrlOperatorReserve" :src="imageUrlOperatorReserve" alt/>
                    <img
                        class="icon-check"
                        v-if="imageUrlOperatorReserve"
                        @click.stop="checkImage('operatorFront')"
                        src="@/assets/login/icon-check-img.png"
                        alt
                    />
                    <img v-if="!imageUrlOperatorReserve" src="@/assets/login/image-card-emblem.png" alt/>
                    <span v-if="!imageUrlOperatorReserve" class="fz14 fc9">上传经办人身份证国徽面照片</span>
                  </div>
                </el-upload>
              </el-form-item>
            </div>

            <el-row>
              <el-col :span="12">
                <el-form-item prop="operatorName" label="经办人姓名">
                  <el-input
                      v-model="ruleForm.operatorName"
                      placeholder="请输入经办人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="operatorId" label="经办人身份证号">
                  <el-input
                      v-model="ruleForm.operatorId"
                      placeholder="请输入经办人身份证号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="operatorPhone" label="手机号码" >
                  <el-input
                      type="number"
                      v-model="ruleForm.operatorPhone"
                      :maxlength="11"
                      placeholder="请输入手机号码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label-width="0px">
              <el-button class="next-button" type="primary" @click="submitForm('ruleForm')"
              >确认无误，下一步</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>

    <check-example ref="checkRef"></check-example>
    <face-check ref="faceRef" @subPersonSeal="getCheckId" @submitForm="submitForm"></face-check>
    <Bottom></Bottom>
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import CheckExample from "@/pages/register/components/CheckExample.vue";
import Cookies from "js-cookie";
import FaceCheck from "@/pages/register/physicsSeal/components/FaceCheck.vue";

export default {
  name: "operatorAuthentication",
  components: {FaceCheck, CheckExample, Bottom, Header},
  data() {
    var validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!reg.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      rules: {
        operatorIdCardFront: [
          {
            required: true,
            message: "请上传经办人身份证人像面照片",
            trigger: "change",
          },
        ],
        operatorIdCardBack: [
          {
            required: true,
            message: "请上传经办人身份证国徽面照片",
            trigger: "change",
          },
        ],
        operatorName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        operatorId: [{required: true, validator: validIdCard, trigger: "blur"}],
        operatorPhone: [{required: true, validator: validPhone, trigger: "blur"}],
      },
      ruleForm: {
        endPoint: 'web'
      },
      imageUrlOperatorFront: '',
      imageUrlOperatorReserve: '',
    }
  },
  methods:{
    getCheckId(id){
      // this.$set(this.ruleForm, "checkId", checkId);
      this.$router.push({
        path: "/register/physicsSeal/" + id
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.loading = true
          this.$http.post(this.$api.H5.createApply , JSON.stringify(this.ruleForm)).then(res =>{
            if (res.data.code == 200){
              // window.location.href = res.data.data.faceCertifyUrl
              this.$refs.faceRef.show({faceCertifyUrl: res.data.data.faceCertifyUrl,...this.ruleForm}, "经办人");
              Cookies.set('PhysicalSeal', res.data.data.credential)
              this.loading = false
            }else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      })
    },
    downAuth() {
      top.window.location.href = 'https://www.lngsyz.com/app/授权书.docx'
      // window.open('https://www.lngsyz.com/app/授权书.docx')
    },
    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },
    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          this.imageScene = e.target.result;
        } else if (type == 5) {
          this.imageUrlOperatorFront = e.target.result;
        } else if (type == 6) {
          this.imageUrlOperatorReserve = e.target.result;
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },

    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    changeUpload(e){
      if(e == 'idCardFrontId' || e == 'businessLicenseId' || e == 'operatorIdCardFront' || e == 'operatorIdCardBack'){
        if (typeof GSESC === 'object'){
          this.uploadType = e
          this.visible = true
        }else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }else if(e == 'scene'){
        if (this.ruleForm.legalPersonName && this.ruleForm.legalPersonId){
          this.uploadType = e
          this.visible = true
        }else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },

    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      }else if (flag == "operatorFront") {
        this.srcList.push(this.imageUrlOperatorFront);
      }else if (flag == "operatorReserve") {
        this.srcList.push(this.imageUrlOperatorReserve);
      }else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      }else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },

    request(base, type) {
      let params = {
        businessCode: this.ruleForm.orgCode ? this.ruleForm.orgCode : null,
        type: '' + type,
        imageBase64: base,
      };
      if (type == 5) {
        params.type = '0';
      }else if (type == 6) {
        params.type = '1';
      }
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "legalPersonId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "legalPersonIdCardFront", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "legalPersonIdCardBack", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "orgName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "orgCode", res.data.data.businessCode);
              this.$refs.ruleForm.clearValidate()
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorisation", res.data.data.imageId);
          } else if (type == 4) {
            this.$set(this.ruleForm, "checkId", res.data.data.imageId);
          } else if (type == 5) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "operatorName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "operatorId", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "operatorIdCardFront", res.data.data.imageId);
          } else if (type == 6) {
            this.$set(this.ruleForm, "operatorIdCardBack", res.data.data.imageId);
          }
          if(res.data.data.errMsg){
            this.$message.warning(res.data.data.errMsg);
          }else {
            this.$message.success(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
          if (type == 0) {
            this.imageUrlFront = "";
          } else if (type == 1) {
            this.imageUrlReserve = "";
          } else if (type == 2) {
            this.imageLicenseId = "";
          } else if (type == 3) {
            this.imageAuthorization = "";
          } else if (type == 4) {
            this.imageScene = "";
          }
        }
        this.loading = false;
      });
    },
  }
}
</script>

<style scoped lang="less">
.upload-image {
  display: flex;
  align-items: flex-start;
  margin-bottom: 22px;
  .top-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
  }
}
.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}
::v-deep .el-form-item {
  margin-bottom: 28px !important;
}
::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
